import React from 'react';
import styles from "./WorkSchedule.module.css";
import {WorkingHours} from "./workingHours/WorkingHours";
import {WorkingHoursRequest} from "../../LocationForm";
import {Section} from '../../../../../../elements/section/Section';
import {RootState} from "../../../../../../../app/store";

interface Props<W> {
    title: string;
    backgroundColor?: string;
    updateWorkingHours: (update: WorkingHoursRequest & { fieldName: string }) => void;

    mondayWorkingHoursSelector: (state: RootState) => W | undefined;
    tuesdayWorkingHoursSelector: (state: RootState) => W | undefined;
    wednesdayWorkingHoursSelector: (state: RootState) => W | undefined;
    thursdayWorkingHoursSelector: (state: RootState) => W | undefined;
    fridayWorkingHoursSelector: (state: RootState) => W | undefined;
    saturdayWorkingHoursSelector: (state: RootState) => W | undefined;
    sundayWorkingHoursSelector: (state: RootState) => W | undefined;
}

export const WorkSchedule = <
    W extends WorkingHoursRequest,
>({
      title,
      backgroundColor,
      updateWorkingHours,
      mondayWorkingHoursSelector,
      tuesdayWorkingHoursSelector,
      wednesdayWorkingHoursSelector,
      thursdayWorkingHoursSelector,
      fridayWorkingHoursSelector,
      saturdayWorkingHoursSelector,
      sundayWorkingHoursSelector
  }: Props<W>) => {

    return <Section title={title} backgroundColor={backgroundColor}>
        <div className={styles.workingHoursWrapper}>
            <WorkingHours<W>
                day={"Monday"}
                fieldName={"monday"}
                workingHoursSelector={mondayWorkingHoursSelector}
                updateWorkingHours={updateWorkingHours}
            />
            <WorkingHours<W>
                day={"Tuesday"}
                fieldName={"tuesday"}
                workingHoursSelector={tuesdayWorkingHoursSelector}
                updateWorkingHours={updateWorkingHours}
            />
            <WorkingHours<W>
                day={"Wednesday"}
                fieldName={"wednesday"}
                workingHoursSelector={wednesdayWorkingHoursSelector}
                updateWorkingHours={updateWorkingHours}
            />
            <WorkingHours<W>
                day={"Thursday"}
                fieldName={"thursday"}
                workingHoursSelector={thursdayWorkingHoursSelector}
                updateWorkingHours={updateWorkingHours}
            />
            <WorkingHours<W>
                day={"Friday"}
                fieldName={"friday"}
                workingHoursSelector={fridayWorkingHoursSelector}
                updateWorkingHours={updateWorkingHours}
            />
            <WorkingHours<W>
                day={"Saturday"}
                fieldName={"saturday"}
                workingHoursSelector={saturdayWorkingHoursSelector}
                updateWorkingHours={updateWorkingHours}
            />
            <WorkingHours<W>
                day={"Sunday"}
                fieldName={"sunday"}
                workingHoursSelector={sundayWorkingHoursSelector}
                updateWorkingHours={updateWorkingHours}
                withBorderLine={false}
            />
        </div>
    </Section>
}
